export default __webpack_public_path__ + "static/media/Armbands of the Ravenflight.a3e37c7b.jpg";